import { createContext } from "react";

const PlannerContext = createContext(null);

export default PlannerContext;
